export default __webpack_public_path__ + "img/btn-printer.571280c7.svg";